var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 16.4345V7.56574C20.6243 7.43222 20.5884 7.30125 20.5209 7.18603C20.4534 7.07081 20.3567 6.97543 20.2406 6.90949L12.3656 2.45637C12.2545 2.39219 12.1284 2.3584 12 2.3584C11.8716 2.3584 11.7455 2.39219 11.6344 2.45637L3.75937 6.90949C3.64327 6.97543 3.5466 7.07081 3.47911 7.18603C3.41163 7.30125 3.37572 7.43222 3.375 7.56574V16.4345C3.37572 16.568 3.41163 16.699 3.47911 16.8142C3.5466 16.9294 3.64327 17.0248 3.75937 17.0907L11.6344 21.5439C11.7455 21.608 11.8716 21.6418 12 21.6418C12.1284 21.6418 12.2545 21.608 12.3656 21.5439L20.2406 17.0907C20.3567 17.0248 20.4534 16.9294 20.5209 16.8142C20.5884 16.699 20.6243 16.568 20.625 16.4345V16.4345Z",
    stroke: "#6D798C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.375C13.864 15.375 15.375 13.864 15.375 12C15.375 10.136 13.864 8.625 12 8.625C10.136 8.625 8.625 10.136 8.625 12C8.625 13.864 10.136 15.375 12 15.375Z",
    stroke: "#6D798C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNut);
export default __webpack_public_path__ + "static/media/Nut.b7839e5f03c4fb8a26049e8cdc9328f7.svg";
export { ForwardRef as ReactComponent };